import { useState } from "react";
import { MoveIcon, PlusIcon, TagIcon } from "@/frontend/shared/assets/icons";
import { NormalButton } from "@/frontend/shared/ui/Button";
import styles from "./ActionsHeader.module.scss";
import clsx from "clsx";
import { Typography } from "@/frontend/shared/ui/Typography/Typography";
import { Checkbox } from "@/frontend/shared/ui/Checkbox";
import { DeleteCompanies } from "@/frontend/features/Company/ui/DeleteCompanies/DeleteCompanies";
import { MoveCompany } from "@/frontend/features/Company/ui/MoveCompany/MoveCompany";
import { TPortfolioCompanyWithTotal, TStagesResponse } from "@/frontend/pages/DashboardPage/const/const";
import { TFilterDataProps } from "../filter/model/types/filterData";
import { AddTagsModal } from "../AddTagsModal/ui/AddTagsModal";
import { Tag2Icon } from "@/frontend/shared/assets/icons/Tag2Icon";
import { useScreenWidth } from "@/frontend/shared/lib/hooks/useScreenWidth";
import { SquareNormalButton } from "@/frontend/shared/ui/Button/SquareNormalButton/SquareNormalButton";

export type TActionsHeader = {
  className?: string;
  selected: number[];
  onChange: () => void;
  data?: TStagesResponse;
  triggerRefetch: () => void;
  allCompaniesData: TPortfolioCompanyWithTotal;
};

export function ActionsHeader({
  className,
  selected,
  onChange,
  data,
  triggerRefetch,
  allCompaniesData
}: TActionsHeader) {
  const [shownModal, setShownModal] = useState({ type: "", id: null });

  const isSelected = selected && selected.length > 0;

  const tagsOfSelectedCompanies = allCompaniesData?.portfolioCompanies
    ?.filter((company) => selected.includes(company.id))
    .flatMap((company) => company.tags.map((tag) => tag));

  const isMobile = useScreenWidth() <= 768;

  return (
    <div className={clsx(styles.container, className)}>
      <div className={styles.buttonsContainer}>
        {isSelected && !isMobile && (
          <div className={styles.checkboxContainer}>
            {/* <Checkbox onChange={() => onChange?.()} value={!!selected.length} /> */}
            <Typography variant="label-4" color="greyscale900">
              {selected.length} Selected
            </Typography>
          </div>
        )}
        <SquareNormalButton
          size="large"
          className={styles.btn}
          isDisabled={!isSelected || selected.length > 1}
          variant="secondary"
          onClick={() => setShownModal({ type: "addTags", id: null })}
        >
          <Tag2Icon />
          {!isMobile && "Tag"}
        </SquareNormalButton>
        {/* <MoveCompany
          data={data}
          selectedCompanies={selected || []}
          triggerRefetch={triggerRefetch}
          isDisabled={!isSelected}
        >
          <SquareNormalButton size="large" className={styles.btn} isDisabled={!isSelected} variant="secondary">
            <MoveIcon />

            {!isMobile && "Move"}
          </SquareNormalButton>
        </MoveCompany> */}

        <DeleteCompanies
          isSelected={!isSelected}
          ids={selected || []}
          triggerRefetch={triggerRefetch}
          isDisabled={!isSelected}
        />
        <AddTagsModal
          isOpen={shownModal.type === "addTags"}
          ids={selected}
          onClose={() => setShownModal({ type: "", id: null })}
          triggerRefetch={triggerRefetch}
          currentTags={[]}
          tagsWithIdsData={tagsOfSelectedCompanies}
        />
      </div>
    </div>
  );
}
